export default __webpack_public_path__ + "static/orel-4426c29d6135eeffa77300b043126ffa.webp";